import { Component, Input, SimpleChanges } from '@angular/core';
import { ClrDatagridModule, ClrDatagridSortOrder, ClrIconModule } from "@clr/angular";
import { RouterLink } from "@angular/router";
import { Projects, StatusButtons } from "../../../../_shared/interfaces";
import { AlertService, ConfirmDialogService, IAlertType, ProjectsStoreService } from "../../../../_shared/services";
import { CurrencyPipe, DatePipe } from "@angular/common";
import { ClarityIcons, twoWayArrowsIcon } from '@cds/core/icon';
import moment from 'moment';

@Component({
  selector: 'app-projects-overview',
  standalone: true,
  imports: [
    ClrIconModule,
    ClrDatagridModule,
    RouterLink,
    CurrencyPipe,
    DatePipe
  ],
  templateUrl: './projects-overview.component.html',
  styleUrl: './projects-overview.component.sass'
})
export class ProjectsOverviewComponent {
  projects: Projects[] = [];
  projectID: number = 0;
  descSort = ClrDatagridSortOrder.DESC;
  loading: boolean = true;

  @Input() status!: string;

  statusButtons: StatusButtons[] = [
    { state: 'all', display: '---', label: 'alert-danger', icon: 'info-circle'},
    { state: 'open', display: 'Offen', label: 'alert-info', icon: 'info-circle'},
    { state: 'running', display: 'In Arbeit', label: 'alert-warning', icon: 'info-circle'},
    { state: 'requested', display: 'Projekt', label: 'alert-info', icon: 'info-circle'},
    { state: 'confirmed', display: 'Auftrag', label: 'alert-sucess', icon: 'info-circle'},
    { state: 'lost', display: 'Verloren', label: 'alert-danger', icon: 'check-circle'},
    { state: 'invoiced', display: 'Berechnet', label: 'alert-danger', icon: 'check-circle'},
    { state: 'finished', display: 'Erledigt', label: 'alert-success', icon: 'info-circle'}
  ];

  constructor(
      private prss: ProjectsStoreService,
      private alertDispatcher: AlertService,
      private confirmDialog: ConfirmDialogService,
  ) {
    ClarityIcons.addIcons(twoWayArrowsIcon);
  }

  ngOnInit(): void {
    this.loadList(this.status);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['status']) {
      this.loadList(this.status);
    }
  }

  // Anpassung Farbe und Text des Statusbuttons...
  findButtonStatus(projectstatus: string, buttons: StatusButtons[]) {
    return buttons.findIndex(el => el.state === projectstatus)
  };

  getCellStatus(projectstatus: string) {
    const statusline = this.findButtonStatus(projectstatus, this.statusButtons);
    const idx = statusline >= 0 ? statusline : 0;
    return {
      'statusLabel' : this.statusButtons[idx].label,
      'statusDisplay': this.statusButtons[idx].display,
      'statusIcon': this.statusButtons[idx].icon
    };
  }

  findButtonClass(invoicestatus: string) {
    return "alert " + this.getCellStatus(invoicestatus).statusLabel + " alert-sm";
  }

  formatProjectDate(value: string | null | undefined): string {
    if (!value) {
      return '-';
    }

    const parsed = moment(value, ['DD.MM.YYYY', 'YYYY-MM-DD'], true);
    return parsed.isValid() ? parsed.format('DD.MM.YYYY') : value;
  }
  loadList(status: string) {
    const normalizedStatus = status && status !== '0' ? status : 'all';
    this.loading = true;
    this.projects = [];

    this.prss.getProjectsPPS(normalizedStatus).subscribe({
      next: data => {
        this.projects = data?.object ?? [];
        this.loading = false;

        if (this.projects.length === 0) {
          this.alertDispatcher.show({
            message: 'Keine Projekte gefunden!',
            clrAlertType: IAlertType.WARNING
          }, 3000);
          return;
        }
      },
      complete: () => {
        this.loading = false;
      },
      error: () => {
        this.loading = false;
        return
      }
    });
  }
}
